import { Component, Input } from '@angular/core';
import { Badge } from '../../models/badge.model';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss'
})
export class BadgeComponent {

  @Input() badges!: Badge[];
  @Input() sizeIcon!: number;
  @Input() tooltip: boolean = true;

}
